import React from "react";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
} from "react-icons/fa";
import "./ContactUs.css";

const ContactUs = () => {
  return (
    <section className="contact-section">
      <div className="contact-container">

        {/* Heading */}
        <div className="contact-heading">
          <h2>
            INTERNATIONAL SOCIETY FOR KRISHNA CONSCIOUSNESS
          </h2>

          <p>
            ISKCON Ujjain, Sri Sri Radha MadanMohan welcomes you all
            in this holy land of Ujjain.
          </p>
        </div>

        {/* 3 Inline Cards */}
        <div className="contact-grid">

          {/* Address Card */}
          <div className="contact-card">
            <div className="icon-box">
              <FaMapMarkerAlt />
            </div>

            <h3>Temple Address</h3>

            <p>
              33-37, Hare Krishna Land,
              <br />
              Bharatpuri, Ujjain,
              <br />
              Madhya Pradesh - 456010
            </p>
          </div>

          {/* Guest House Card */}
          <div className="contact-card featured-card">
            <div className="icon-box white-icon">
              <FaPhoneAlt />
            </div>

            <h3>Guest House Booking</h3>

            <a
              href="https://guesthouse.iskconujjain.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="website-link"
            >
              guesthouse.iskconujjain.com
            </a>

            <div className="contact-info">
              <p>Booking Contact</p>

              <a href="tel:9424698700">
                +91 94246 98700
              </a>
            </div>

            <div className="contact-info">
              <p>For any other Details WhatsApp on</p>

              <a
                href="https://wa.me/919424940422"
                target="_blank"
                rel="noopener noreferrer"
              >
                +91 94249 40422
              </a>
            </div>
          </div>

          {/* Contact Card */}
          <div className="contact-card">
            <div className="icon-box">
              <FaEnvelope />
            </div>

            <h3>Contact Us</h3>

            <a
              href="mailto:info@iskconujjain.com"
              className="email-link"
            >
              info@iskconujjain.com
            </a>

            <p>
              Contact us for temple events,
              seva booking, festivals,
              and spiritual programs.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ContactUs;